/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import "./src/css/styles.css"
import UI from "./src/scripts/ui.js"
import "./src/css/custom.css"

const ui = UI()

export const onClientEntry = () => {}

export const onRouteUpdate = ({ location }) => {
  setTimeout(ui.init(), 100) // TODO: we could make the menu a component that handles its lifecycle and events
  if (location.hash !== "") {
    setTimeout(() => {
      ui.goToAnchor(location.hash)
    }, 100)
  }
}
